import { render, staticRenderFns } from "./allLabAssignmentsOverview.vue?vue&type=template&id=c717e9bc&scoped=true"
import script from "./allLabAssignmentsOverview.vue?vue&type=script&lang=js"
export * from "./allLabAssignmentsOverview.vue?vue&type=script&lang=js"
import style0 from "./allLabAssignmentsOverview.vue?vue&type=style&index=0&id=c717e9bc&prod&scoped=true&lang=css"
import style1 from "./allLabAssignmentsOverview.vue?vue&type=style&index=1&id=c717e9bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c717e9bc",
  null
  
)

export default component.exports